import { Controller } from '@hotwired/stimulus';
import * as Sentry from '@sentry/browser';

let hasLoadedScriptTag = false;
let hasAddedLoadHandler = false;

export default class extends Controller {
  static targets = ['scriptTag'];

  scriptTagTarget: HTMLScriptElement;

  static values = {
    key: String,
  };

  connect() {
    // Remove the zEACLoaded global that the Zendesk widget uses to short-circuit subsequent loads.
    // This allows the Zendesk widget to reload after Turbolinks visits.
    // https://mentalized.net/journal/2019/04/26/zendesk-web-widget-turbolinks/
    window.zEACLoaded = undefined;

    try {
      this.setAuthenticateUserCallback();
      hasAddedLoadHandler = true;
      hasLoadedScriptTag = true;
    } catch {
      if (!hasLoadedScriptTag) {
        this.scriptTagTarget.addEventListener('load', () => {
          if (!hasAddedLoadHandler) {
            this.setAuthenticateUserCallback();
            hasAddedLoadHandler = true;
          }
        });
        hasLoadedScriptTag = true;
      }
    }
  }

  private setAuthenticateUserCallback() {
    window.zE?.('messenger:on', 'open', () => {
      this.authenticateUser();
    });
  }

  private authenticateUser() {
    window.zE?.('messenger', 'loginUser', callback => {
      fetch('/app/ultimate_authentication')
        .then(response => {
          if (response.ok) {
            return response.text();
          }

          window.zE?.('messenger', 'close');
          window.zE?.('messenger', 'hide');
          return null;
        })
        .then(data => {
          if (data !== null) callback(data);
        })
        .catch((error: Error) =>
          Sentry.captureException(new Error('ultimate_chatbot_authentication_error', { cause: error }))
        );
    });
  }
}
